import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            关于羞羞动漫网站的常见问题解答
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/60"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex items-start gap-3">
                <span className="text-accent-500 flex-shrink-0 mt-0.5 font-semibold">A</span>
                <span>{item.a}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}